<template>
  <AppHeader>Sort Customers <small>({{ customers.length }})</small></AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Name</th>
            <th>Group</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody ref="customersTable">

          <tr v-for="customer in customersFiltered" :key="customer.id" :id="customer.id" :class="{'bg-green-300': customer.is_new == true}">
            <td class="py-2 sortable-handle"><i class="px-3 ion-md-menu"></i></td>
            <td>#{{ customer.id }}</td>
            <td><b>{{ customer.name }} ({{ toInr(customer.wallet_balance) }})</b></td>
            <td>{{ customer.group.name }}</td>
            <td class="text-left">{{ customer.address }}</td>
          </tr>

        </tbody>
      </table>
    </div>

    <div class="mt-5 text-center">
      <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="updateOrder">Update Order</button>
    </div>
  </div>

</template>

<script>
import Sortable from 'sortablejs';
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'CustomersSort',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      sortable: null,
      customers: [],
      customersFiltered: [],
      group: 'all',
      groups: [],
      sort: 'group.sort_no',
      order: 'asc',
    };
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('get', 'customers/get-in-order', null, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.groups = resp.groups;
          this.customers = resp.data;
          this.customersFiltered = this.customers;
          this.sortList();

          this.$nextTick(() => {
            this.sortable = new Sortable(this.$refs.customersTable, {
              handle: '.sortable-handle',
              chosenClass: 'bg-red-300',
              onEnd: (e) => {
                if (e.oldIndex != e.newIndex) e.item.classList.add('bg-amber-200');
              },
            });
          });
        } else alert(resp.message ?? 'Could not update now, Try again later');
      });
    },

    updateOrder() {
      if (!confirm('Are you sure?')) return;

      this.state = 'loading';
      let data = Array.from(this.$refs.customersTable.children).map(c => Number(c.id));

      this.request('POST', 'customers/update-order', {customers: data}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.getData();
        else alert(resp.message ?? 'Could not update now, Try again later');
      });
    },

    sortList() {
      this.customersFiltered.sort((a, b) => {
        let aData = this.getDeepValue(a, this.sort), bData = this.getDeepValue(b, this.sort);
        return (aData == bData ? 0 : aData < bData ? -1 : 1) * (this.order == 'desc' ? -1 : 1);
      });
    },
  },

  created() {
    if (!this.$store.state.user.id) this.$router.push('/dash');
    else this.getData();
  }
}
</script>
